// GENERATO AUTOMATICAMENTE da scripts/generateApiDocs.js
// Non modificare manualmente - aggiornato ad ogni commit
export const API_DOCS = [
  {
    method: 'GET',
    endpoint: '/api/anagrafiche/premi-insegna?insegnaClienteId=N',
    requestBody: null,
    response: '[{"id":5,"anno":2026,"tipo":"PFA","descrizione":"Premio fine anno","metodoCalcolo":"PROGRESSIVO","scaglioni":[{"id":11}]}]'
  }
] as const;

export type ApiDoc = typeof API_DOCS[number];
